module.exports = __webpack_public_path__ + "img/shgs1.0119f968.png";